
{
  "familyId": "TOPO-EU-FYSISCH",
  "questions": [
    {
      "id": "TOPO-EU-FYSISCH-001",
      "familyId": "TOPO-EU-FYSISCH",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_fysisch",
      "questionType": "multiple_choice",
      "question": "Welk type landschap vind je vooral in Nederland, Noord-Duitsland en Denemarken?",
      "options": ["Laagland (vlak, onder zeeniveau of net erboven)", "Hooggebergte (boven 2000 m)", "Middelgebergte (500–2000 m)", "Steppe (droog grasland)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Landschapstypen Europa",
            "content": "Europa heeft drie hoofdtypen: laagland (NL, N-Duitsland, Denemarken — vlak, vaak onder zeeniveau), middelgebergte (Ardennen, Harz — heuvels 500-2000 m), hooggebergte (Alpen, Pyreneeën — boven 2000 m).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fysisch_landschapstypen",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Nederland, Noord-Duitsland en Denemarken liggen in de Noord-Europese Laagvlakte. Dit is vlak land, vaak net boven of zelfs onder zeeniveau. Nederland is beroemd om zijn polders en dijken — grote delen liggen onder de zeespiegel.",
        "solutionSteps": [
          "Nederland, Noord-Duitsland en Denemarken liggen laag",
          "Dit gebied heet de Noord-Europese Laagvlakte",
          "Vlak land, vaak onder zeeniveau",
          "Daarom heeft Nederland dijken en polders"
        ],
        "distractorExplanations": {
          "0": "Goed! Nederland, Noord-Duitsland en Denemarken zijn laagland.",
          "1": "Hooggebergte (boven 2000 m) vind je in de Alpen en Pyreneeën — in Midden- en Zuid-Europa. Nederland is juist het tegenovergestelde: zo vlak en laag mogelijk.",
          "2": "Middelgebergte (500–2000 m) vind je in de Ardennen (België) en het Harz-gebergte (Duitsland). Nederland heeft geen bergen — het hoogste punt is de Vaalserberg (322 m).",
          "3": "Steppe is droog grasland, typisch voor Centraal-Azië. Nederland is juist nat en groen door de vele regen en rivieren."
        }
      }
    },
    {
      "id": "TOPO-EU-FYSISCH-002",
      "familyId": "TOPO-EU-FYSISCH",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_fysisch",
      "questionType": "multiple_choice",
      "question": "De Straat van Gibraltar is een smalle zeestraat. Welke twee gebieden verbindt deze straat?",
      "options": ["De Middellandse Zee en de Atlantische Oceaan", "De Noordzee en de Oostzee", "De Zwarte Zee en de Middellandse Zee", "De Rode Zee en de Indische Oceaan"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Straat van Gibraltar",
            "content": "De Straat van Gibraltar ligt tussen Spanje (Europa) en Marokko (Afrika). Het is de enige natuurlijke verbinding tussen de Middellandse Zee en de Atlantische Oceaan. De straat is maar ~14 km breed.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fysisch_gibraltar",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De Straat van Gibraltar ligt tussen Spanje (Europa) en Marokko (Afrika). Het is de enige natuurlijke doorgang tussen de Middellandse Zee en de Atlantische Oceaan. De straat is op het smalste punt maar ~14 km breed — je kunt Afrika zien vanaf Spanje.",
        "solutionSteps": [
          "Straat van Gibraltar = tussen Spanje en Marokko",
          "Verbindt de Middellandse Zee (oost) met de Atlantische Oceaan (west)",
          "Enige natuurlijke doorgang",
          "~14 km breed op het smalste punt"
        ],
        "distractorExplanations": {
          "0": "Goed! De Straat van Gibraltar verbindt de Middellandse Zee met de Atlantische Oceaan.",
          "1": "De Noordzee en Oostzee zijn verbonden via de Sont (bij Denemarken), niet via Gibraltar. Gibraltar ligt in het zuiden van Europa, niet in het noorden.",
          "2": "De Zwarte Zee en Middellandse Zee zijn verbonden via de Bosporus (bij Istanbul, Turkije). De Straat van Gibraltar ligt aan de andere kant van de Middellandse Zee.",
          "3": "De Rode Zee en Indische Oceaan zijn verbonden via de Straat van Bab el-Mandeb (bij Jemen). Dat ligt in het Midden-Oosten, niet in Europa."
        }
      }
    },
    {
      "id": "TOPO-EU-FYSISCH-003",
      "familyId": "TOPO-EU-FYSISCH",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_fysisch",
      "questionType": "multiple_choice",
      "question": "Welk natuurlijk verschijnsel zorgt ervoor dat Noorwegen warmere winters heeft dan je op die breedtegraad zou verwachten?",
      "options": ["De Golfstroom (warme zeestroming)", "Vulkanische activiteit", "De Alpen als windscherm", "De korte afstand tot de Noordpool"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Golfstroom",
            "content": "De Golfstroom is een warme zeestroming vanuit de Golf van Mexico. Hij brengt warm water naar de kusten van West-Europa, waardoor landen als Noorwegen, het VK en Ierland mildere winters hebben dan verwacht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fysisch_golfstroom",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Golfstroom is een warme zeestroming die vanuit de Golf van Mexico warm water naar West-Europa brengt. Daardoor heeft de Noorse kust veel mildere winters dan bijvoorbeeld Canada op dezelfde breedtegraad. Zonder de Golfstroom zou Noorwegen veel kouder zijn.",
        "solutionSteps": [
          "Noorwegen ligt ver naar het noorden",
          "Toch zijn de winters relatief mild aan de kust",
          "De Golfstroom brengt warm water vanuit de Golf van Mexico",
          "Warm water = mildere luchttemperatuur aan de kust"
        ],
        "distractorExplanations": {
          "0": "Goed! De Golfstroom zorgt voor mildere winters in Noorwegen.",
          "1": "IJsland heeft vulkanen, maar Noorwegen heeft weinig vulkanische activiteit. Vulkanen verwarmen geen hele kusten. Onthoud: de Golfstroom is de reden.",
          "2": "De Alpen liggen in Midden-Europa, ver van Noorwegen. Ze hebben geen invloed op het Noorse klimaat. Onthoud: de Golfstroom (zeestroming) is de sleutel.",
          "3": "De korte afstand tot de Noordpool zou Noorwegen juist kouder maken, niet warmer. De Golfstroom compenseert die koude. Onthoud: zonder Golfstroom zou Noorwegen veel kouder zijn."
        }
      }
    },
    {
      "id": "TOPO-EU-FYSISCH-004",
      "familyId": "TOPO-EU-FYSISCH",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_fysisch",
      "questionType": "multiple_choice",
      "question": "Wat is een delta? En welk Europees land is grotendeels een delta?",
      "options": ["Gebied waar een rivier in zee uitmondt en land afzet — Nederland", "Een vulkanisch eiland — IJsland", "Een bergpas tussen twee toppen — Zwitserland", "Een diepe fjord aan de kust — Noorwegen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieredelta's",
            "content": "Een delta ontstaat waar een rivier in zee uitmondt. De rivier zet zand en klei af, waardoor nieuw land ontstaat. Nederland is grotendeels een delta van de Rijn, Maas en Schelde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fysisch_delta",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een delta is een gebied waar een rivier in zee uitmondt en sediment (zand, klei) afzet. Nederland is grotendeels een delta van de Rijn, Maas en Schelde. Het vlakke, lage land is ontstaan doordat deze rivieren eeuwenlang materiaal hebben afgezet.",
        "solutionSteps": [
          "Delta = riviermonding waar land wordt afgezet",
          "De Rijn, Maas en Schelde monden uit in Nederland",
          "Ze hebben zand en klei afgezet → vlak, laag land",
          "Daarom is Nederland zo vlak en laag"
        ],
        "distractorExplanations": {
          "0": "Goed! Een delta is een riviermonding met landafzetting, en Nederland is grotendeels een delta.",
          "1": "IJsland is een vulkanisch eiland, maar dat is geen delta. Een delta gaat over rivieren die land afzetten, niet over vulkanen.",
          "2": "Een bergpas is een lage doorgang tussen bergtoppen. Dat is iets heel anders dan een delta. Zwitserland heeft bergpassen, maar geen grote delta's.",
          "3": "Een fjord is een smalle, diepe inham aan de kust (door gletsjers gevormd). Noorwegen heeft fjorden, maar dat is iets anders dan een delta."
        }
      }
    },
    {
      "id": "TOPO-EU-FYSISCH-005",
      "familyId": "TOPO-EU-FYSISCH",
      "module": "Topo",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "europa",
      "subSkill": "topo_fysisch",
      "questionType": "matching",
      "question": "Koppel elk fysisch-geografisch begrip aan het juiste Europese voorbeeld.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "Delta (riviermonding)", "right": "Nederland (Rijn/Maas)"},
          {"left": "Fjord (smalle inham)", "right": "Noorwegen"},
          {"left": "Schiereiland (uitstekend land)", "right": "Italië (de laars)"},
          {"left": "Vulkanisch eiland", "right": "IJsland"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Fysisch-geografische begrippen",
            "content": "Delta = riviermonding (Nederland). Fjord = smalle inham door gletsjers (Noorwegen). Schiereiland = land dat uitsteekt in zee (Italië). Vulkanisch eiland = door vulkanen gevormd (IJsland).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "fysisch_begrippen_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Delta → Nederland (Rijn/Maas). Fjord → Noorwegen. Schiereiland → Italië. Vulkanisch eiland → IJsland. Elk begrip beschrijft een ander type landschap dat door natuurlijke processen is gevormd.",
        "solutionSteps": [
          "Delta (riviermonding) → Nederland (Rijn en Maas)",
          "Fjord (smalle inham door gletsjers) → Noorwegen",
          "Schiereiland (uitstekend land) → Italië (de laars)",
          "Vulkanisch eiland → IJsland (op de Mid-Atlantische Rug)"
        ]
      }
    }
  ]
}
